﻿$.fn.dxCtrlFichier2VisuImage = function custom_dxCtrlFichier2VisuImage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2visuimage");
        this.instance = new cdxCtrlFichier2VisuImage(this, option);
    }
    return this;
}

window.cdxCtrlFichier2VisuImage = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        var url = option.itemData.url
        if (url.startsWith("~")) url = url.substring(1)
        $("<div style='height:100%;width:100%'/>").appendTo(container).dxCtrlImageEditor({
            value: url + "?d=" + new Date().getTime(),
            readonly: true
        });
    }

    this.element = function () { return container }

    mConstruit();
}